<div class="field-wrapper" [formGroup]="formGroup">
  
  <div class="field-label">
    <label class="mb-0" style="font-weight: 500;">
      {{field.label}}<span style="color:red" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="ms-1 text-decoration-none" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="field-input">
    <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload style="font-weight: 500; display: block; margin-bottom: 8px;">
    
    <p style="font-weight: 500; margin: 8px 0;">{{fileName}}</p>
    
    <a *ngIf="uploadedFile != null" target="_blank" [href]="uploadedFile" style="display: block;">
      Uploaded file
    </a>
  </div>
</div>